<div class="bad-url">
  <div layout="row" flex layout-align="center center">
      <div layout="column" layout-align="center">
         <h1> Page Not Found </h1>
           <p>Sorry, the page you're looking for doesn't exist.</p>
      </div>
  </div>
</div>